import { SearchMode } from "helpers/api";
import { getMaxCreditsPerMonth } from "constants/searchModeConfig";
import { SubscriptionTier } from "helpers/subscription";

/**
 * Calculate the total Deep Search credits including bonus credits
 * @param isNotSignedIn - Whether the user is not signed in
 * @param subscriptionTier - The user's subscription tier
 * @param bonusDeepSearchCredits - Bonus Deep Search credits added by CS (defaults to 0)
 * @returns Total credits (base + bonus) or null for unlimited
 */
export const getTotalDeepSearchCredits = (
  isNotSignedIn: boolean,
  subscriptionTier: SubscriptionTier,
  bonusDeepSearchCredits: number = 0
): number | null => {
  const baseCredits = getMaxCreditsPerMonth(
    SearchMode.PRO_RESEARCH,
    isNotSignedIn,
    subscriptionTier
  );

  // If base credits is null (unlimited), return null
  if (baseCredits === null) {
    return null;
  }

  // Anonymous users can't have bonus credits (no account to add them to)
  if (isNotSignedIn) {
    return baseCredits;
  }

  // Return base + bonus credits for signed-in users
  return baseCredits + bonusDeepSearchCredits;
};
